import router from "next/router";
import Image from "next/image";
import Link from "next/link";
import { VFC, memo, useCallback } from "react";

import { useTheme } from "next-themes";
import { Btn } from "components/utils";

import { getAuth, signOut } from "firebase/auth";
import { signin } from "lib/signin";

import { CurrentUser } from "lib/type";

import { FcGoogle } from "react-icons/fc";
import { FaRegEdit, FaRegUserCircle, FaSun, FaMoon } from "react-icons/fa";
import { VscSettingsGear } from "react-icons/vsc";

type changeTthemeBtnProps = {
  user: CurrentUser;
  changeTheme: () => void;
  theme: string | undefined;
};

const ChangeTthemeBtn: VFC<changeTthemeBtnProps> = memo(
  ({ user, changeTheme, theme }) => {
    return (
      <li className={`${user ? "mt-6" : "mt-6 mb-auto"} mb-6`}>
        <button className="flex w-full items-center" onClick={changeTheme}>
          {theme === "light" ? (
            <>
              <FaMoon className="mr-1" />
              ダークモード
            </>
          ) : (
            <>
              <FaSun className="mr-1" />
              ライトモード
            </>
          )}
        </button>
      </li>
    );
  }
);

ChangeTthemeBtn.displayName = "ChangeTthemeBtn";

const UserMenu: VFC<{ user: CurrentUser }> = ({ user }) => {
  const { theme, setTheme } = useTheme();
  const changeTheme = useCallback(
    () => setTheme(theme === "light" ? "dark" : "light"),
    [setTheme, theme]
  );

  const signOutFnc = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => router.push("/"))
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };

  return (
    <>
      {!user ? (
        <>
          <li>
            <button onClick={signin} className="flex w-full items-center">
              <FcGoogle />
              サインイン
            </button>
          </li>
          <ChangeTthemeBtn {...{ user, changeTheme, theme }} />
        </>
      ) : (
        <>
          <li className="text-center">
            <Link href={`/users/${user.uid}`} prefetch={false}>
              <a className="block">
                <div className="nextimg shadow-light-700 dark:shadow-dark-400 mx-auto mb-2 shadow-lg md:w-44">
                  <Image
                    src={user.avatar || "/default.svg"}
                    alt={user.name || ""}
                    width="100%"
                    height="100%"
                    layout="responsive"
                    objectFit="cover"
                    className="rounded-lg"
                  />
                </div>
                <p className="mx-auto table text-left leading-5">{user.name}</p>
              </a>
            </Link>
          </li>
          <li className="mt-4">
            <Link href="/post">
              <a>
                <Btn Icon={FaRegEdit}>記事を書く</Btn>
              </a>
            </Link>
          </li>
          <li className="mt-8">
            <Link href={`/users/${user.uid}`} prefetch={false}>
              <a className="flex items-center">
                <FaRegUserCircle className="mr-2" />
                マイページ
              </a>
            </Link>
          </li>
          <li className="mt-6">
            <Link href={`/users/${user.uid}/settings`}>
              <a className="flex items-center">
                <VscSettingsGear className="mr-2" />
                プロフィール設定
              </a>
            </Link>
          </li>
          <ChangeTthemeBtn {...{ user, changeTheme, theme }} />
          <li className="mt-auto text-sm opacity-70">
            <button onClick={signOutFnc}>サインアウト</button>
          </li>
        </>
      )}
    </>
  );
};

export default UserMenu;
